export default __webpack_public_path__ + "static/media/CGhome.df99adf1.png";